module.exports = __webpack_public_path__ + "static/media/vocab.1a5c7cb4.png";